var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuggestedMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 6C12.3688 6 12.6673 6.29848 12.6673 6.66667V13.3333C12.6673 13.7015 12.3688 14 12.0007 14C11.6325 14 11.334 13.7015 11.334 13.3333V6.66667C11.334 6.29848 11.6325 6 12.0007 6Z",
    fill: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
    fill: "#7E716D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00065 8.66699C4.36884 8.66699 4.66732 8.96547 4.66732 9.33366V13.3337C4.66732 13.7018 4.36884 14.0003 4.00065 14.0003C3.63246 14.0003 3.33398 13.7018 3.33398 13.3337V9.33366C3.33398 8.96547 3.63246 8.66699 4.00065 8.66699Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuggestedMenuIcon);
export default __webpack_public_path__ + "static/media/suggested-menu-icon.221ceb13c9b4e2ebb35fd5aeb50400a2.svg";
export { ForwardRef as ReactComponent };